import { HttpService } from "../../modules/shared/services/http.service";
import { 
	Commission, 
	CommissionCreateDto, 
	CommissionBackendResponse,
	CommissionRateModifier, 
	CommissionRateModifierCreateDto, 
	CommissionRateModifierUpdateDto,
	CommissionTierCreateDto,
	CommissionTierUpdateDto,
	CommissionTierBackendResponse
} from "../../modules/shared/model/commission.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createCommission = async (data: CommissionCreateDto): Promise<CommissionBackendResponse> => {
	const response = await HttpService.post("api/v1/commissions", data, headers, true);
	return response;
};

export const updateCommission = async (id: string, data: Partial<CommissionCreateDto>): Promise<CommissionBackendResponse> => {
	const response = await HttpService.patch(`api/v1/commissions/${id}`, data, headers, true);
	return response;
};

export const getCommissionById = async (id: string): Promise<CommissionBackendResponse> => {
	const response = await HttpService.get(`api/v1/commissions/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getCommissions = async (query?: Record<string, string | number | boolean>): Promise<{ data: CommissionBackendResponse[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/commissions${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteCommission = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/commissions/${id}`, { "x-custom-lang": "en" }, true);
};

export const getCommissionStats = async (): Promise<{
	activeRules: number;
	avgCommission: number;
	totalCategories: number;
	activeModifiers: number;
}> => {
	const response = await HttpService.get("api/v1/commissions/stats", true, { "x-custom-lang": "en" });
	return response;
};

// Commission Rate Modifier Actions
export const createCommissionRateModifier = async (data: CommissionRateModifierCreateDto): Promise<CommissionRateModifier> => {
	const response = await HttpService.post("api/v1/commission-rate-modifiers", data, headers, true);
	return response;
};

export const updateCommissionRateModifier = async (id: string, data: CommissionRateModifierUpdateDto): Promise<CommissionRateModifier> => {
	const response = await HttpService.patch(`api/v1/commission-rate-modifiers/${id}`, data, headers, true);
	return response;
};

export const getCommissionRateModifierById = async (id: string): Promise<CommissionRateModifier> => {
	const response = await HttpService.get(`api/v1/commission-rate-modifiers/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getCommissionRateModifiers = async (query?: Record<string, string | number | boolean>): Promise<{ data: CommissionRateModifier[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/commission-rate-modifiers${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteCommissionRateModifier = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/commission-rate-modifiers/${id}`, { "x-custom-lang": "en" }, true);
};

// Commission Tier Actions
export const createCommissionTier = async (data: CommissionTierCreateDto): Promise<CommissionTierBackendResponse> => {
	const response = await HttpService.post("api/v1/commission-tiers", data, headers, true);
	return response;
};

export const updateCommissionTier = async (id: string, data: CommissionTierUpdateDto): Promise<CommissionTierBackendResponse> => {
	const response = await HttpService.patch(`api/v1/commission-tiers/${id}`, data, headers, true);
	return response;
};

export const getCommissionTierById = async (id: string): Promise<CommissionTierBackendResponse> => {
	const response = await HttpService.get(`api/v1/commission-tiers/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getCommissionTiers = async (query?: Record<string, string | number | boolean>): Promise<{ data: CommissionTierBackendResponse[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/commission-tiers${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteCommissionTier = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/commission-tiers/${id}`, { "x-custom-lang": "en" }, true);
};
